module.exports = {"130824001":"中兴路街道","130824100":"滦平镇","130824101":"长山峪镇","130824102":"红旗镇","130824103":"金沟屯镇","130824104":"虎什哈镇","130824105":"巴克什营镇","130824106":"张百湾镇","130824107":"付营子镇","130824108":"大屯镇","130824109":"火斗山镇","130824200":"平坊满族乡","130824201":"安纯沟门满族乡","130824205":"小营满族乡","130824206":"西沟满族乡","130824207":"邓厂满族乡","130824208":"五道营子满族乡","130824209":"马营子满族乡","130824210":"付家店满族乡","130824212":"两间房乡","130824213":"涝洼乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130824.json
// module id = 206
// module chunks = 0